export default {
    // api: "http://192.168.2.12:8086",
    // api: "http://192.168.20.132:8700",
    // 测试地址
    api: "https://test-village.hemeixiangcun.xn--fiqs8s",
    // 线上在用
    // api:"https://village.hemeixiangcun.xn--fiqs8s"
    // wx:"https://applet.aiteyixia.cn"
}


// WEBPACK FOOTER //
// ./src/serve.js